import React from 'react';
import { Provider } from 'react-redux';
// import FA from 'utils/FontAwesomeLoader';
import store from './redux/store';
import App from './App';

const AppContainer = () => {
  return (
    <Provider store={store}>
      <App />
    </Provider>
  );
};

export default AppContainer;
